import React from 'react';
import Hero from '../components/Hero';
import About from '../components/About';
import Services from '../components/Services';
import Locations from '../components/Locations';
import WhyChooseUs from '../components/WhyChooseUs';
import Testimonials from '../components/Testimonials';
import DeveloperPartners from '../components/DeveloperPartners';
import BlogInsights from '../components/BlogInsights';
import ContactForm from '../components/ContactForm';

const Home = () => {
  return (
    <div>
      <Hero />
      <About />
      <Services />
      <Locations />
      <WhyChooseUs />
      <Testimonials />
      <DeveloperPartners />
      <BlogInsights />
      <ContactForm />
    </div>
  );
};

export default Home;
